var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardTitleImage2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 25,
    viewBox: "0 0 32 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.76562 14.5843C1.76562 11.7527 4.15359 9.45714 9.03336 9.45714C13.9131 9.45714 16.3011 11.7527 16.3011 14.5843C16.3011 15.0348 15.9693 15.4 15.5601 15.4H2.50665C2.09739 15.4 1.76562 15.0348 1.76562 14.5843Z",
    stroke: "#06513D",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7588 3.7C11.7588 5.19117 10.5386 6.4 9.03336 6.4C7.52816 6.4 6.30796 5.19117 6.30796 3.7C6.30796 2.20883 7.52816 1 9.03336 1C10.5386 1 11.7588 2.20883 11.7588 3.7Z",
    stroke: "#06513D",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8984 14.5843C15.8984 11.7527 18.2864 9.45714 23.1662 9.45714C28.0459 9.45714 30.4339 11.7527 30.4339 14.5843C30.4339 15.0348 30.1021 15.4 29.6929 15.4H16.6395C16.2302 15.4 15.8984 15.0348 15.8984 14.5843Z",
    stroke: "#06513D",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8916 3.7C25.8916 5.19117 24.6714 6.4 23.1662 6.4C21.661 6.4 20.4408 5.19117 20.4408 3.7C20.4408 2.20883 21.661 1 23.1662 1C24.6714 1 25.8916 2.20883 25.8916 3.7Z",
    stroke: "#06513D",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.80469 22.8671C5.80469 18.9342 8.95548 15.746 15.3941 15.746C21.8326 15.746 24.9834 18.9342 24.9834 22.8671C24.9834 23.4928 24.5457 24 24.0057 24H6.78243C6.24244 24 5.80469 23.4928 5.80469 22.8671Z",
    stroke: "#06513D",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9901 7.75C18.9901 9.82107 17.3801 11.5 15.3941 11.5C13.408 11.5 11.798 9.82107 11.798 7.75C11.798 5.67893 13.408 4 15.3941 4C17.3801 4 18.9901 5.67893 18.9901 7.75Z",
    stroke: "#06513D",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardTitleImage2);
export default __webpack_public_path__ + "static/media/dashboardTitleImage2.0368887bb9bb370e8628708253f9ca00.svg";
export { ForwardRef as ReactComponent };